<script setup>
import { reactive, ref, onMounted } from 'vue'
import axios from 'axios'
import Swal from 'sweetalert2'
import draggable from 'vuedraggable'

const props = defineProps({
  department: {
    type: Object,
    required: true
  },
  creators: {
    type: Object,
    required: true
  }
})
const data = reactive({
  isLoading: false
})

const orderCreators = ref(props.creators)

onMounted(() => {
  setOrder()
})

const setOrder = () => {
  let order = 1
  orderCreators.value.map((creator) => {
    creator.display_order = order
    order += 1
    return creator
  })
}

const cancel = () => {
  window.location.href = `/departments/${props.department.id}`
}

const submit = async () => {
  data.isLoading = true
  setOrder()
  try {
    await axios.put(`/departments/${props.department.id}/display_order`, {
      creators: orderCreators.value
    })
    data.isLoading = false
    await Swal.fire({
      icon: 'success',
      title: '更新が完了しました',
      text: '',
      confirmButtonText: '部署詳細へ移動',
      confirmButtonColor: '#40BF6C',
      reverseButtons: true,
      allowOutsideClick: false
    })
    window.location.href = `/departments/${props.department.id}`
  } catch (error) {
    data.isLoading = false
    await Swal.fire({
      icon: 'error',
      title: '更新に失敗しました',
      text: 'クリエイター情報をご確認ください',
      confirmButtonText: 'OK',
      confirmButtonColor: '#40BF6C',
      reverseButtons: true,
      allowOutsideClick: false
    })
  }
}
</script>

<template>
  <vue-element-loading :active="data.isLoading" is-full-screen />
  <div class="overflow-hidden rounded-lg bg-white shadow">
    <div class="-my-2 -mx-4 overflow-x-auto p-8 sm:-mx-6 lg:-mx-8">
      <div class="inline-block min-w-full py-2 align-middle md:px-6 lg:px-8">
        <div class="grid min-w-full grid-cols-12 border border-gray-200">
          <div
            class="col-span-1 py-3.5 px-3 text-left text-sm font-semibold text-gray-900"
          >
            表示順
          </div>
          <div
            class="col-span-4 py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-6 md:pl-0"
          >
            名前
          </div>
          <div
            class="col-span-5 py-3.5 px-3 text-left text-sm font-semibold text-gray-900"
          >
            管理エージェント
          </div>
          <div
            class="col-span-2 py-3.5 px-3 text-left text-sm font-semibold text-gray-900"
          >
            メイン所属部署
          </div>
        </div>
        <draggable v-model="orderCreators" item-key="display_order" tag="div">
          <template #item="{ element }">
            <div
              class="grid min-w-full grid-cols-12 border border-gray-200 py-5"
            >
              <div
                class="col-span-1 whitespace-nowrap px-3 text-sm text-gray-500"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke-width="1.5"
                  stroke="currentColor"
                  class="h-6 w-6"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    d="M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25h16.5"
                  />
                </svg>
              </div>
              <div
                class="col-span-4 whitespace-nowrap pl-4 pr-3 text-sm font-medium text-gray-900 hover:text-gray-500 sm:pl-6 md:pl-0"
              >
                {{ element.name }}
              </div>
              <div
                class="col-span-5 whitespace-nowrap px-3 text-sm text-gray-500"
              >
                {{ element.agent }}
              </div>
              <div
                class="col-span-2 whitespace-nowrap px-3 text-sm text-gray-500"
              >
                {{ element.department }}
              </div>
            </div>
          </template>
        </draggable>
      </div>
    </div>
  </div>

  <div class="flex justify-end py-3">
    <button
      class="group w-28 whitespace-nowrap rounded border border-gray-500 bg-white p-2.5 font-medium text-gray-800 hover:border-transparent hover:bg-gray-500 hover:text-white"
      @click="cancel"
    >
      <span class="sr-only lg:not-sr-only">キャンセル</span>
    </button>

    <button
      class="ml-4 w-28 rounded bg-green-200 p-2 px-4 font-bold text-gray-700 hover:bg-green-300"
      @click="submit"
    >
      <span class="sr-only lg:not-sr-only">更新</span>
    </button>
  </div>
</template>
